<div class="sidenav-content" >
    <div class="bcontainer2">
        <div class="main-content"> 

    <div class="spacer2"></div>

    <div class="containter">
        <a href="#" style="color: #333; text-decoration: none; outline: none;" *ngIf="!blck"><img src="assets/images/closeIcon.svg" matTooltip="Close" class="close-icon"></a>
      <div class="mfhd">
        <i
          class="fa fa-angle-left"
          aria-hidden="true"
          style="padding-right: 5px"
        ></i
        >Privacy Policy

      </div>
      

    <p>Thank you for choosing <b>XDBrain (XDB)</b>. Protecting your privacy is of utmost importance to us. This Privacy Policy outlines how we collect, use, store, and protect your information when you use our pattern based storage system services. By accessing or using our services, you agree to the practices described in this Privacy Policy.</p>

    <ol>
        <li class="dhd">Information We Collect</li>
        <ol type="a">
            <li>
            User Information
            <ol type="i">
                <li><b>Account Information:</b> Name, login password, login information (including browser type, IP address, unique device identifiers, language preference, referring site, the date and time of access, operating system, and mobile network information) and email.</li>
                <li><b>User Preferences:</b> Preferences related to storage service customization.</li>
            </ol>
            </li>
            <div class="spacer"></div>
            <li>
            Personal and Institutional Data
            <ol type="i">
                <li>All personal and institutional data is securely stored in private storage. <b>XDB</b> cannot access your stored data. See <i>Data Storage and Security</i> section for more information.</li>                
            </ol>
            </li> 
            <div class="spacer"></div>
            <li>
            Usage Data
            <ol type="i">
                <li>We collect metadata and usage statistics, such as login activity and feature usage patterns.</li>                
            </ol>
            </li>
            <div class="spacer"></div>
            <li>
            Technical Information
            <ol type="i">
                <li>Device identifiers, browser type, IP address, operating system, cookies, and session activity logs.</li>                
            </ol>
            </li>
            <div class="spacer"></div>
            <li>
            Personally Identifiable Information (“PII”)
            <ol type="i">
                <li>We do not collect PII from you other than as disclosed in Section 1a.</li>
                <li>We discourage you from adding information such as your name, address, date of birth, social security number, tax identification number or other PII to the chat function. This information may be shared with third-party providers.</li>
            </ol>
            </li>            

        </ol>
        
        <div class="spacer2"></div>

        <li class="dhd">How We Use Your Information</li>
        <ol type="a">
            <li><b>Service Delivery:</b> To process, analyze, and enhance the user experience.</li>
            <li><b>Improvement of Services:</b> To enhance usability, security, and develop new features.</li>
            <li><b>Account Management:</b> To manage subscriptions and provide customer support.</li>
            <li><b>Compliance and Legal Obligations:</b> To enforce terms and prevent fraudulent activity.</li>
        </ol>

        <div class="spacer2"></div>

        <li class="dhd">Data Storage and Security</li>
        <ol type="a">
        <li>
            Storage
            <ol type="i">
                <li>All documents and data are securely stored in encrypted environments, accessible only by authorized users.</li>                
            </ol>
        </li>
        <div class="spacer"></div>
        <li>Encrypted messages
            <ol type="i">
                <li>All encrypted messages are stored securely until you delete them.</li>
                <li>You may delete your messages or revoke access at any time.</li>
                <li>Loss of your private key will result in permanent loss of access to your data, as <b>XDB</b> has no recovery access.</li>
                <li>The LLM response is encrypted using your RSA public key before being saved in <b>XDB</b>'s database.</li>
                <li>Since the private key is only available to you, <b>XDB</b> cannot decrypt or access the contents of your stored messages; ensuring complete zero-knowledge storage.</li>
            </ol>
        </li>
        <div class="spacer"></div>
        <li>
            Security Measures
            <ol type="i">
                <li>Data is encrypted in transit <b>(TLS)</b> and at rest.</li>
                <li>Access restricted through role-based controls and multi-factor authentication.</li>
                <li>Regular security audits and penetration testing.</li>
                <li>Our systems are compliant with SOC 2 Type II, covering security, availability, and confidentiality of our information.</li>                
            </ol>
        </li>
        <div class="spacer"></div>
        <li>
            Your Responsibilities
            <ol type="i">
                <li>You are responsible for securely managing and backing up your ECDSA and RSA private keys.</li>
                <li>You are also responsible for complying with the usage terms of your chosen LLM provider.</li>                             
            </ol>
        </li>        
        </ol>

        <div class="spacer2"></div>

        <li class="dhd">Sharing of Information</li>
        <ol type="a">
        <li>
            With Your Consent
            <ol type="i">
                <li>We may share your information if you explicitly authorize us to do so.</li>
            </ol>
        </li>
        <div class="spacer"></div>
        <li>
            Service Providers
            <ol type="i">
                <li>We may share limited information with trusted third-party providers under strict confidentiality agreements.</li>
                <li>Some of our third-party providers use Large Language Models (“LLM”). These LLM providers do not use file uploads, outputs, or prompts to train their models. </li>                
            </ol>
        </li>
        <div class="spacer"></div>
        <li>
            Use of External AI Models (LLM)
            <ol type="i">
                <li>When you submit a message via the <b>XDB</b> chat interface, it may be sent to third-party LLMs</li>
                <li>You bring your own API key to connect to these LLMs. <b>XDB</b> does not manage, proxy, or store your API credentials.</li>
                <li><b>XDB</b> does not log, cache, or persist any unencrypted messages sent to or returned from the LLM.</li>
            </ol>
        </li>
        <div class="spacer"></div>
        <li>
            Legal Requirements
            <ol type="i">
                <li>We may disclose information if required by law or to protect <b>XDB</b> and its users.</li>                
            </ol>
        </li>        
        </ol>


        <div class="spacer2"></div>

        <li class="dhd">Your Rights</li>
        <ol type="a">
        <li>
           <b>Access & Portability:</b> Request a copy of your stored data.
        </li>
        <li>
            <b>Correction & Deletion:</b> Request correction or deletion of data.
        </li>
        <li>
           <b>Consent Withdrawal:</b> Withdraw consent at any time.
        </li>
        <li>
           <b>Opt-Out:</b> Unsubscribe from marketing communications.
        </li> 
        <li>
           These requests will be typically processed within 2 business days.
        </li>               
        </ol>
        
        
        <div class="spacer2"></div>

        <li class="dhd">Retention Policy</li>
        <ol type="a">
        <li>
           Data is retained only as necessary for service or legal compliance. Any remaining data will be permanently deleted 30 days after you close your account. <b>XDB</b> cannot access your stored data even after you delete your account. If you lose your credentials, <b>XDB</b> cannot recover your stored data.
        </li>
        </ol>
        
        
        <div class="spacer2"></div>

        <li class="dhd">Cookies and Tracking Technologies</li>
        <ol type="a">
        <li>
           <b>XDB</b> uses cookies for user experience improvement and analytics. Manage settings via your browser.
        </li>
        </ol>
        
        <div class="spacer2"></div>

        <li class="dhd">Children's Privacy</li>
        <ol type="a">
        <li>
           <b>XDB</b> is not intended for users under 18. We do not knowingly collect data from children.
        </li>
        <li>Users under 13 are not allowed to use <b>XDB</b>.</li>
        </ol>  
        
        <div class="spacer2"></div>

        <li class="dhd">International Data Transfers</li>
        <ol type="a">
        <li>
           Your data may be processed in regions where our service providers operate, ensuring legal compliance.
        </li>
        </ol>         

        <div class="spacer2"></div>

        <li class="dhd">Changes to This Privacy Policy</li>
        <ol type="a">
        <li>
           We may update this policy periodically. Significant changes will be communicated via email or app notices.
        </li>
        </ol>  
        
        <div class="spacer2"></div>

        <li class="dhd">Contact Us</li>
        <ol type="a">
        <li>
           If you have questions, contact us at:
            <ol type="i">
                <li><b>XDB Support<br>
                    Email: <a href="mailto:support@netxd.com" class="routeClr">{{'support@netxd.com'}}</a></b>
                </li>                
            </ol>
        </li>
        </ol>  
        
       <div class="spacer2"></div>

        <li class="dhd">Acknowledgment</li>
        <ol type="a">
        <li>
           By using <b>XDB</b>, you acknowledge that you have read, understood, and agree to this Privacy Policy.
        </li>
        </ol>          
        

    </ol>


        <div class="spacer5"></div>



            </div>
            </div> 
        </div>
        
    </div>
